import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import "./view.css";
import {
  get_adviser_details,
  get_mou_details,
  mou_approve_status,
  mou_revert_status,
  update_adviser_status,
  update_mou_status,
} from "../admin.api";
import Snackbar from "../../../components/snackbar/snackbar";
import Loader from "../../../components/loader/loader";
import jwtDecode from "jwt-decode";
import moment from "moment";
export default function View(props) {
  const [data, setData] = useState([]);
  const [isActive, setIsActive] = useState(true);
  const [snackMessage, setSnackMessage] = useState("");
  const [isSnackError, setIsSnackError] = useState(false);
  const [snackOpen, setSnackOpen] = useState(false);
  const [url, setUrl] = useState("");
  const servInstance = process.env.REACT_APP_BASE_URL;
  let result = servInstance.substring(0, servInstance?.length - 4);
  const handleEdit = () => { };
  const handleDownload = () => { };
  let adminType = Number(jwtDecode(props.state.payload).user_type);
  const selectedParam = useParams();
  const getDetails = (id) => {
    get_mou_details(id).then((res) => {
      let tdata = res.Mou;
      setData(tdata);
      setIsActive(false);
    });
  };
  useEffect(() => {
    getDetails(selectedParam.id);
  }, []);
  const handleDownloadBiodata = () => {
    let path = `${result}${data.biodata}`;
    window.open(path, "_blank");
  };
  const handleApproveStatus = (status) => {
    let data = { status: status };
    setIsActive(true);
    mou_approve_status(selectedParam.id, data)
      .then((res) => {
        setSnackMessage(res.message);
        setIsSnackError(false);
        setSnackOpen(true);
        setIsActive(false);
      })
      .catch((error) => {
        setSnackMessage(error.message);
        setIsSnackError(true);
        setSnackOpen(true);
        setIsActive(false);
      });
  };
  const handleRevertStatus = (status) => {
    let data = { status: status };
    setIsActive(true);
    mou_revert_status(selectedParam.id, data)
      .then((res) => {
        setSnackMessage(res.message);
        setIsSnackError(false);
        setSnackOpen(true);
        setIsActive(false);
      })
      .catch((error) => {
        setSnackMessage(error.message);
        setIsSnackError(true);
        setSnackOpen(true);
        setIsActive(false);
      });
  };
  const snackbarClose = (flag) => {
    setSnackMessage("");
    setIsSnackError(false);
    setSnackOpen(false);
    if (!flag) {
      props.history.push("/admin-mou");
    }
  };
  return (
    <div>
      <Snackbar
        message={snackMessage}
        error={isSnackError}
        open={snackOpen}
        close={snackbarClose}
      />
      <Loader open={isActive} />
      <div className="view-container">
        <span className="d-flex justify-content-between">
          <h6 className="mb-0 pt-2">
            <b>MOU Details</b>
          </h6>
          {/*      
        <button type="button" className="btn btn-primary">
          Back to List
        </button> */}
        </span>
        <hr />
        <button
          type="button"
          className="btn btn-primary btn-sm  mb-3"
          onClick={(e) => {
            props.history.push("/admin-mou");
          }}
        >
          Back
        </button>
        <div className="data">
          <div className="row">
            <div className="col-3">Organization</div>
            <div className="col-1">:</div>
            <div className="col-7">
              {data?.organization_name || "Not Available"}
            </div>
          </div>
          {data?.kspace_signatory_area &&
            <div className="row">
              <div className="col-3">Signatory from KSPACE</div>
              <div className="col-1">:</div>
              <div className="col-7 mou-bw">
                {data?.kspace_signatory_area || "Not Available"}
              </div>
            </div>

          }
          {data?.partner_signatory_area &&
            <div className="row">
              <div className="col-3">Signatory from partner organization</div>
              <div className="col-1">:</div>
              <div className="col-7 mou-bw">
                {data?.partner_signatory_area || "Not Available"}
              </div>
            </div>

          }
          <div className="row">
            <div className="col-3"> Date From</div>
            <div className="col-1">:</div>
            <div className="col-7 mou-bw">
              {data?.from_date
                ? moment(data.from_date).format("DD-MM-YYYY")
                : "Not Available"}
            </div>
          </div>
          <div className="row">
            <div className="col-3"> Date To</div>
            <div className="col-1">:</div>
            <div className="col-7 mou-bw">
              {data?.to_date
                ? moment(data.to_date).format("DD-MM-YYYY")
                : "Not Available"}
            </div>
          </div>

          <div className="row">
            <div className="col-3"> Logo</div>
            <div className="col-1">:</div>
            <div className="col-7">
              <img width={200} src={data?.logo} alt="" />
            </div>
          </div>
          {/* 
          {adminType === 1 && (
            <div className="d-flex justify-content-center mt-4">
              <button
                type="button"
                className="btn btn-approve btn-success mr-2"
              >
                Submit for Acceptance
              </button>

              <button type="button" className="btn btn-reject btn-danger">
                Reject
              </button>
            </div>
          )} */}
          {adminType === 2 && data && data.status === 0 && (
            <div className="d-flex justify-content-center mt-4">
              <button
                type="button"
                className="btn btn-approve btn-success mr-2"
                onClick={() => handleApproveStatus(1)}
              >
                Approve
              </button>
              <br />
              <button
                type="button"
                className="btn btn-reject btn-danger"
                onClick={() => handleRevertStatus(0)}
              >
                Reject
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
